import { EMPTY_STRING } from "../constants/Dictionary";

export const stringFormat = (text: string) => text || "-";

const trimLineSpaces = (line: string): string => {
  let start = 0;
  let end = line.length;

  while (start < end && /\s/.test(line[start])) {
    start++;
  }
  while (end > start && /\s/.test(line[end - 1])) {
    end--;
  }

  return line.slice(start, end);
};

export const trimSpaces = (text: string): string =>
  text
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .split("\n")
    .map(trimLineSpaces)
    .join("\n")
    .trim();
export const capitalize = (str: string | undefined | null): string =>
  str
    ? str
        .split(" ")
        .map(
          (item) =>
            `${item.charAt(0).toUpperCase()}${item.slice(1).toLowerCase()}`,
        )
        .join(" ")
    : EMPTY_STRING;
